import { put, takeLatest } from 'redux-saga/effects';
import {
  CREATE_TAG,
  CREATE_TAG_SUCCESS,
  DELETE_TAG,
  DELETE_TAG_SUCCESS,
  GET_TAG,
  GET_TAG_SUCCESS,
  GET_TAGS,
  GET_TAGS_SUCCESS,
  UPDATE_TAG,
  UPDATE_TAG_SUCCESS,
} from '@/store/types/tag';
import { onFailRequest, onSuccessRequest } from '@/utils';
import {
  requestDeleteTag,
  requestGetTag,
  requestGetTags,
  requestPostTag,
  requestPutTag,
} from '@/store/requests/tag';

function* getTag({ data }) {
  const response = yield requestGetTag(data);
  yield put({ type: GET_TAG_SUCCESS, payload: response.data });
}

function* getTags({ query }) {
  try {
    const { data, metadata } = yield requestGetTags(query);
    yield put({ type: GET_TAGS_SUCCESS, payload: { data, metadata } });
  } catch (error) {
    yield onFailRequest({ error });
  }
}

function* createTag({ payload, callback }) {
  try {
    const response = yield requestPostTag(payload);
    yield put({ type: CREATE_TAG_SUCCESS, payload: { data: response.data } });
    yield onSuccessRequest({ response });
    callback(response.data);
  } catch (error) {
    yield onFailRequest({ error });
  }
}

function* updateTag({ id, payload }) {
  try {
    const response = yield requestPutTag(id, payload);
    yield put({ type: UPDATE_TAG_SUCCESS, payload: response.data });
    yield onSuccessRequest({ response });
  } catch (error) {
    yield onFailRequest({ error });
  }
}

function* deleteTag({ id, callback }) {
  try {
    const response = yield requestDeleteTag(id);
    yield put({ type: DELETE_TAG_SUCCESS, payload: response.data });
    yield onSuccessRequest({ response });
    callback();
  } catch (error) {
    yield onFailRequest({ error });
  }
}

export default [
  takeLatest(GET_TAG, getTag),
  takeLatest(GET_TAGS, getTags),
  takeLatest(CREATE_TAG, createTag),
  takeLatest(UPDATE_TAG, updateTag),
  takeLatest(DELETE_TAG, deleteTag),
];
